import { API_BASE_URL } from '../../services/api';

export function tournamentAuthHeaders(json = true) {
  const token = localStorage.getItem('auth_token');
  const facilityId = localStorage.getItem('active_facility_id');
  return {
    ...(json && { 'Content-Type': 'application/json' }),
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(facilityId && { 'X-Facility-Id': facilityId }),
  };
}

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}/tournaments${path}`, {
    ...options,
    headers: options.headers || tournamentAuthHeaders(),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload.success) {
    throw new Error(payload.message || 'Tournament request failed');
  }
  return payload;
}

export const getTournamentHome = () => request('/home');

export const getTournament = (tournamentId) => request(`/${tournamentId}`);

export const getTournamentRegistrations = (tournamentId, status = 'pending') => {
  const query = status ? `?status=${encodeURIComponent(status)}` : '';
  return request(`/${tournamentId}/registrations${query}`);
};

export const reviewTournamentRegistration = (registrationId, action, body = {}) => (
  request(`/registrations/${registrationId}/${action}`, {
    method: 'PUT',
    headers: tournamentAuthHeaders(),
    body: JSON.stringify(body),
  })
);
